import SimpleText, { TextHelper } from "@/components/texts/simpleText";
import AjudaAccordions from "@/components/acorddions/ajudaAccordions";
import Events from "@/utils/Events";
import { useSelector} from "react-redux";
import { GET_OFFER_TYPE } from "../../store/slices/offerSlice";
import themes from "@/styles/themes";

export default function PrecisaAjuda() {
    const offer_type = useSelector(GET_OFFER_TYPE)
    const events = new Events();
    return (
        <>
            <AjudaAccordions title={'Precisa de ajuda?'} LabelEvent="precisa_de_ajuda_abrir">
                <SimpleText>
                    <>Em caso de dúvidas, ou se quiser recuperar seu “Usuário”, ligue para:</> <br/>
                    <a href="tel:4003-5323" onClick={()=> events.trigger("precisa_de_ajuda_sac_capitais",{ offer_type })}><b>4003-5323</b></a> <>(capitais e regiões metropolitanas)</> <br/>
                    <a href="tel:0800 014 7720" onClick={()=> events.trigger("precisa_de_ajuda_sac_demais_localidades",{ offer_type })}><b>0800 014 7720</b></a> <>(demais localidades; exceto ligações via celular)</> <br/>
                    <br/>
                    De 2ª a 6ª feira, das 6h30 às 18h. Sábados, domingos e feriados, das 6h30 às 13h.
                </SimpleText>
                <SimpleText>
                    <span>Central de Vendas</span>
                    <TextHelper>Ligue para o Televendas <a href="tel:0800 770 2166" 
                        onClick={()=> events.trigger("precisa_de_ajuda_televendas_telefone",{ offer_type })
                    }><b>0800 770 2166</b></a> ou entre em contato pelo <a target="_blank" href="https://api.whatsapp.com/send?phone=5511992482333&text&source&data"
                        onClick={()=> events.trigger("precisa_de_ajuda_televendas_whatsapp",{ offer_type })}
                    >WhatsApp</a></TextHelper>
                </SimpleText>
            </AjudaAccordions>
        </>
    )
}